<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <div mat-dialog-title>
    <span i18n class="title dialog-title">Пазы</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <ng-container *ngIf="data$ | async as data">
        <mat-table #tableSlots *ngIf="!data.error" [dataSource]="dataSourceSlots" class="slot-table">
          <!-- Select material Column -->
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)">
              </mat-checkbox>
            </mat-cell>
          </ng-container>

          <!-- Slot name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell i18n *matHeaderCellDef>Название</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <p class="text-truncate">{{ item }}</p>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row class="butt-replacement-row" *matRowDef="let item; columns: displayedColumns"></mat-row>
        </mat-table>

        <div *ngIf="data.error">
          {{ data.error | json }}
        </div>

        <div *ngIf="!data.error && !data.result">Loading…</div>
      </ng-container>
    </ng-container>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button
      i18n
      mat-raised-button
      class="mat-accent mr-4"
      (click)="dialogRef.close(selection.selected.length > 0 ? selection.selected[0] : undefined)"
      >ОК</button
    >
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
